"use client";

import React from "react";
import { serializeToReact } from "./serializeToReact";
import { LexContentType } from "@/types/common";

interface LexicalRichTextProps {
  contentV2: LexContentType;
  language?: AppLocale;
}

export const LexicalRichText = ({ contentV2, language = "te" }: LexicalRichTextProps) => {
  if (!contentV2) {
    return null;
  }

  return <div className="article-body">{serializeToReact(contentV2, language)}</div>;
};
